import {CategoryInterface} from "../../interfaces/catalog/CategoryInterface";
import {Link} from "react-router-dom";
import {useState, useEffect} from "react";
import {formatBoldText} from "../../utils/formatBoldText";

// Уровень категории кодируется в catalog_code блоками по 3 цифры
const CATEGORY_LEVEL_WITHOUT_IMAGE = 5;

export function TopItem({category, filtersQuery}: {category: CategoryInterface, filtersQuery?: string}) {
    const [imagePath, setImagePath] = useState<string>('');
    const hideImage = Math.ceil(category.catalog_code.length / 3) >= CATEGORY_LEVEL_WITHOUT_IMAGE;

    useEffect(() => {
        if (hideImage) {
            return;
        }

        const pngPath = '/images/catalog/' + category.catalog_code + '.png';
        const defaultPath = 'https://www.pride.ru/catalog/icons/' + category.catalog_code.substring(0, 3) + '.svg';

        // Проверяем наличие PNG изображения
        const img = new Image();
        img.onload = () => {
            setImagePath(pngPath);
        };
        img.onerror = () => {
            setImagePath(defaultPath);
        };
        img.src = pngPath;
    }, [category.catalog_code, hideImage]);

    return (<div className="col-6 col-md-4 col-xxl-3 category__item">
        <Link to={'/catalog/list/' + category.catalog_code + '/' + category.human_url + (filtersQuery ? '?' + filtersQuery : '')} className="category__item-body">
            {!hideImage && <div className="h-100 category__item-fon position-absolute">
                <picture>
                    <img className="top-catalog-image" src={imagePath} alt=""/>
                </picture>
            </div>}
            <div className="m-0 bs-t-big mt-3">{formatBoldText(category.full_name)}</div>
        </Link>
    </div>)
}